import React, { HTMLProps, useState } from 'react';
import { Card, CardProps, Col, Row } from 'react-bootstrap';

import cx from 'classnames';

import VideoPlayer from 'components/VideoPlayer/VideoPlayer';
import { IFileProperties } from 'models/fileProperties';

import s from './FullWidthContent.module.scss';

interface FullWidthContentProps extends CardProps {
  media: IFileProperties;
  transcript?: string;
  mediaAlt?: string;
  style?: any;
  className?: string;
  videoPlayerProps?: HTMLProps<HTMLElement>;
}
const FullWidthContent: React.FC<FullWidthContentProps> = ({
  media,
  mediaAlt,
  className,
  transcript,
  videoPlayerProps,
  ...props
}) => {
  const isVideo = media.mimetype?.toLowerCase().indexOf('video') !== -1;
  const [transcriptIsVisible, setTranscriptIsVisible] = useState(false);

  const toggleTranscript = () => {
    setTranscriptIsVisible(!transcriptIsVisible);
  };

  return (
    <div>
      <Card
        className={cx(
          'overflow-hidden',
          'p-0',
          'no-rounded-corners',
          'no-shadow',
          'bg-light-blue',
          className,
        )}
        {...props}
      >
        <Card.Body className="p-0">
          {media && !isVideo && (
            <div className={cx(s['full-width-image-wrapper'])}>
              <img
                loading="lazy"
                className="w-100"
                src={media.url}
                alt={mediaAlt}
              />
            </div>
          )}
          {media && isVideo && (
            <VideoPlayer
              {...(videoPlayerProps || {})}
              videoURL={media.url}
              videoMimetype={media.mimetype}
              onClickReadTranscript={toggleTranscript}
            />
          )}
        </Card.Body>
      </Card>
      {transcript && (
        <Row className="m-0">
          <Col lg={11} className="offset-lg-1 p-0">
            {transcriptIsVisible && (
              <Card className="bg-light-grey no-shadow mt-4">
                <Card.Body>
                  <div dangerouslySetInnerHTML={{ __html: transcript }} />
                </Card.Body>
              </Card>
            )}
          </Col>
        </Row>
      )}
    </div>
  );
};

export default FullWidthContent;
